import { render, staticRenderFns } from "./color-show.vue?vue&type=template&id=11ba757e"
import script from "./color-show.vue?vue&type=script&lang=js"
export * from "./color-show.vue?vue&type=script&lang=js"
import style0 from "./color-show.vue?vue&type=style&index=0&id=11ba757e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports